module.exports = __webpack_public_path__ + "static/banner_home_agence-1f4f0e99bb2c587a562a78357030a7ab.png";